<template>
  <div id="app" :class="{ 'mobile-device': isMobileDevice, 'desktop-device': !isMobileDevice, 'wechat-browser': isWechatBrowser }">
    <!-- 设备检测组件 -->
    <device-detector />
    <router-view/>
  </div>
</template>

<script>
import { isMobile, isWechat } from '@/utils/mobile';
import { getDeviceType, DeviceType } from '@/utils/deviceRedirect';
import DeviceDetector from '@/components/DeviceDetector.vue';

export default {
  name: 'App',
  components: {
    DeviceDetector
  },
  data() {
    return {
      isMobileDevice: false,
      isWechatBrowser: false,
      deviceType: DeviceType.DESKTOP
    };
  },
  created() {
    // 检测设备类型
    this.detectDevice();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    detectDevice() {
      this.deviceType = getDeviceType();
      this.isMobileDevice = this.deviceType === DeviceType.MOBILE;
      this.isWechatBrowser = isWechat();
    },
    handleResize() {
      // 检测设备类型并更新状态
      this.detectDevice();
    }
  }
};
</script>

<style lang="scss">
/* 移动端适配基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

html, body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  font-size: 16px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

#app {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  color: #333;
  background-color: #f5f5f5;
}

/* 移动端1px边框问题解决方案 */
.border-1px {
  position: relative;
}

.border-1px::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
  transform: scaleY(0.5);
  transform-origin: 0 100%;
}

/* 禁止长按链接与图片弹出菜单 */
a, img {
  -webkit-touch-callout: none;
}

/* 去掉点击时的高亮效果 */
a, input, button {
  outline: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
